'use strict'

export default class ListController {

  /*@ngInject*/
  constructor ($http) {
    this.$http = $http
  }

  $onInit () {
    this.getList()
  }

  getList () {
    this.$http.get('/api/1/keyboard').then(res => {
      this.list = res.data
    })
  }

  delete (id) {
    if (confirm('确定？')) {
      this.$http.delete(`/api/1/keyboard/${id}`).then(res => {
        this.getList()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/keyboard/list/list.controller.js